import { recordAnalyticsEvent } from '@/api/widget/analytics'
import { useFlowState } from '@/stores/useFlowState'
import { getContactID, getCurrentGlobalID, getCurrentMenuType, getEcomMenuProvider, getInitialUIDs } from '@/stores/useSessionStore'
import { isDemoMode, useWidgetStore } from '@/stores/useWidgetStore'
import { AnalyticsEventRequest } from '@/types/widget'
import { clearAttribution, getAttributionDetails } from '@/utils/attribution'
import { getDeviceId, getDeviceProfileFields } from '@/utils/device'
import { logger } from '@/utils/logger'
import { getSessionId } from '@/utils/session'

const CHECKOUT_ACTIONS = ['purchase', 'checkout', 'completed order', 'completedorder']

export function track(eventType: string, action: string, details: Record<string, any> = {}): void {
  // Demo mode doesn't send analytics events
  if (isDemoMode()) return

  try {
    const flowState = useFlowState.getState()
    const route = flowState.currentFlow
      ? `${flowState.currentFlow}/${flowState.currentStep ?? 'unknown'}`
      : (flowState.currentStep ?? '')

    const attribution = getAttributionDetails()
    const enrichedDetails = { ...attribution, ...details }
    const deviceProfile = getDeviceProfileFields()

    const payload: AnalyticsEventRequest = {
      uids: getInitialUIDs(),
      event_type: 'internal',
      action,
      details: enrichedDetails,
      deviceId: getDeviceId(),
      sessionId: getSessionId(),
      url: window.location.href,
      iframeURL: '',
      os: deviceProfile.os || navigator.platform || 'unknown',
      deviceClass: deviceProfile.deviceClass,
      browser: deviceProfile.browser,
      userAgent: deviceProfile.userAgent,
      mode: useWidgetStore.getState().isFloatingWidgetMode ? 'floating' : 'fpe',
      ecomPlatform: getEcomMenuProvider() ?? '',
      route,
      contactID: getContactID(),
      source: 'widget',
    }

    const globalId = getCurrentGlobalID()
    const menuType = getCurrentMenuType()

    recordAnalyticsEvent(payload, { globalId, menuType })
      .then((response) => {
        logger.log('analytics track success', { eventType, action, details: enrichedDetails, response })
      })
      .catch((err) => {
        logger.error('analytics track failed', { eventType, action, details: enrichedDetails, error: err })
      })

    if (CHECKOUT_ACTIONS.includes(action.toLowerCase())) {
      clearAttribution()
    }
  } catch (err) {
    logger.error('analytics track error', err)
  }
}
